<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » QR(URL)生成の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>QR(URL)生成の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/qrcode.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 言語選択ボタン
        </div>
        <div class="manual-explain">
          クリックすることでプロジェクトに登録済みの言語一覧画面が表示されます。<br>
          言語選択（複数選択可）すると、選択した言語のQR/URLを追加で生成します。
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of QR (URL) Generation
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of QR (URL) Generation</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_qrcode.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Language Selection Button
        </div>
        <div class="manual-explain">
          Clicking this button displays a list of languages registered to the project.<br>
          When selecting languages (multiple selections allowed), QR codes/URLs for the selected languages will be additionally generated.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> QR Generation Button
        </div>
        <div class="manual-explain">
          Clicking this button displays the <a [href]="qrcodeResultLink">QR Code Generation Result Screen</a> for the selected floor/exhibit page URLs.<br>
          The button is activated by checking the selection checkboxes in the list.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> URL Generation Button
        </div>
        <div class="manual-explain">
          Clicking this button displays the <a [href]="urlResultLink">URL Generation Result Screen</a> for the selected floor/exhibit page URLs.<br>
          The button is activated by checking the selection checkboxes in the list.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Filter/Attributes
        </div>
        <div class="manual-explain">
          Filters the data displayed in the exhibit list.<br>
          * Filtering criteria: Facility name, Building/Category, Floor/Display Group, ID, Exhibit Name
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Floor/Exhibit List
        </div>
        <div class="manual-explain">
          Displays a list of floors and exhibit information already added to the facility's "Floor/Display Group List".<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
